import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './cadastroPF.scss';
import useFetch from '../../../components/hooks/useFetch';
import useAlerta from '../../../components/hooks/useAlerta';
import { CADASTRAR_MEUCORREIOS_PF } from '../../../services/cadastro';
import FormCadastroPF from './FormCadastroPF';
import FormCadastroPFEstrangeiro from './FormCadastroPFEstrangeiro';
import { getIPAddress } from '../../../components/utils/GetIPAddress';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/form/Input';

const CadastroPF = () => {
  const { t } = useTranslation();
  const { request } = useFetch();
  const { abreAlerta } = useAlerta();
  const navigate = useNavigate();
  const [nacionalidade, setNacionalidade] = React.useState('1');
  const [tenhoCpf, setTenhoCpf] = React.useState('1');
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };

    fetchIPAddress();
  }, []);
  const handleNacionalidade = (event) => {
    setNacionalidade(event.target.value);
    if (event.target.value === '1') {
      setTenhoCpf('1');
    } else {
      setTenhoCpf('0');
    }
  };

  const incluirLogin = async (data) => {
    const { response } = await request(
      CADASTRAR_MEUCORREIOS_PF(data, ipAddress),
    );

    if (response.ok) {
      const meioEnvioTelefone = data.foneMovel;
      const meioEnvioDDD = data.dddMovel;
      const meioEnvioEmail = data.email;
      const meioEnvio = data.meioEnvio;
      const idCorreios = data.idCorreios;
      navigate('/finalizaCadastroToken', {
        state: {
          meioEnvio,
          meioEnvioEmail,
          meioEnvioTelefone,
          meioEnvioDDD,
          idCorreios,
        },
      });
    }
  };

  return (
    <>
      <div className="conteudo alterar-dados">
        <div
          id="cadastro-pf"
          className="cadastro-dados card bg-superficie elev1"
        >
          <img
            alt={t('cadastro.accessibility.carol_image')}
            id="img-carol-boasvindas"
            src="/images/carol-perfil.png"
          />

          <h2>{t('cadastro.titles.individual')}</h2>

          <div className="controle nacionalidade">
            <label className="radio">
              <Input
                type="radio"
                id="brasileiro"
                name="nacionalidade"
                value="1"
                checked={nacionalidade === '1'}
                onChange={handleNacionalidade}
              />
              <div className="subtitulo-p">{t('cadastro.forms.options.brazilian')}</div>
            </label>

            <label className="radio">
              <input
                type="radio"
                id="estrangeiro"
                name="nacionalidade"
                value="0"
                checked={nacionalidade === '0'}
                onChange={handleNacionalidade}
              />
              <div className="subtitulo-p">{t('cadastro.forms.options.foreign')}</div>
            </label>
          </div>

          <p className="justificado">
            {t('cadastro.messages.info.rfb_explanation')}&ensp;
            <a
              href="https://cav.receita.fazenda.gov.br/autenticacao/login"
              target="_blank"
              rel="noopener noreferrer"
              className="link-grande"
            >
              cav.receita.fazenda.gov.br/autenticacao/login
            </a>
          </p>

          {nacionalidade === '1' ? (
            <FormCadastroPF onSubmit={incluirLogin} />
          ) : (
            <FormCadastroPFEstrangeiro onSubmit={incluirLogin} />
          )}
        </div>
      </div>
    </>
  );
};

export default CadastroPF;
